import React from 'react';
import { Link } from 'react-router-dom';

import { MCButton, OtpField, TextField } from 'src/components/basic';
import BaseComponent from 'src/components/BaseComponent';

import {
  withRouter,
  scssVariables as variables,
  lang,
  formatDuration,
  permissions,
  isAdminPage
} from 'src/helpers';

import model from './model';
import LANG_CONST from 'src/helpers/lang/const';

let intervalId = 'SetNewPassword';

const urlPrefix = isAdminPage() ? 'ADMIN_' : '';

class ResetPw extends BaseComponent {
  componentDidMount() {
    model.subscribe(this.subscription);
    setTimeout(() => {
      if (!model.state.email && !model.state.phoneNumber) {
        this.navigate(permissions.PAGES[urlPrefix + 'FORGOT_PASSWORD_PAGE'].path);
      }
    }, 1);
    this.setState({ loading: false });
    this.init();
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
  }

  init = () => {
    model.resetApiState('verify');
    model.resetApiState('resetPw');
    this.timer(() => model.state.resetExpired > Date.now(), intervalId);
  };
  handleSubmit = (event) => {
    event.preventDefault();

    if (model.state.verified)
      return model.resetPw((err, res) => {
        if (res?.ok) return;
        if (res.expired) {
          model.setState({ resetExpired: res.expired });
          this.timer(() => model.state.resetExpired > Date.now(), intervalId);
        }
      });

    let error;
    if (!model.state.code) {
      error = 'Code is required';
    }
    if (!error && model.state.code?.length !== model.state.codeLength) {
      error = 'Code is invalid';
    }

    if (error)
      return model.setInvalidApi('verify', {
        length: 1,
        code: error
      });

    model.verify((err, res) => {
      if (res?.ok) {
        model.setState({ verified: true });
      } else if (res.expired) {
        model.setState({ resetExpired: res.expired });
        this.timer(() => model.state.resetExpired > Date.now(), intervalId);
      }
    });
  };
  continueBtn = (event) => {
    event.preventDefault();
    if (model.isLogged) {
      this.navigate(permissions.PAGES[urlPrefix + 'LOGIN_PAGE'].path);
    } else {
      model.loginPassword(model.state.authData, () => this.navigate('/'));
    }
  };

  renderCodeInput = () => {
    const apiStateId = 'verify';
    let { invalid } = model.getApiState(apiStateId);
    let { codeLength } = model.getState();
    let { handleChange } = model;

    return (
      <div className={'mc-grow'}>
        <OtpField
          template={6}
          name={'code'}
          type='opt'
          inputType={'tel'}
          value={model.input('code').toString()}
          onChange={handleChange}
          label={lang.t(LANG_CONST.text.enter_code_from, {
            type: model.state.resetByPhone ? 'phone' : 'mail'
          })}
          invalid={invalid}
          numInputs={codeLength}
          containerStyle={{
            flex: 1,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between'
          }}
        />
      </div>
    );
  };

  renderPasswordInput = () => {
    const apiStateId = 'resetPw';
    let { invalid } = model.getApiState(apiStateId);
    let { handleChange, handleBlur } = model;

    return (
      <>
        <div className='mc-box-title-note'>{lang.t(LANG_CONST.text.new_pw_should_diff_old_pw)}</div>
        <TextField
          template={6}
          name={'password1'}
          label={LANG_CONST.password}
          type={'password'}
          value={model.input('password1')}
          onChange={(n, v) => {
            model.resetApiState(apiStateId);
            handleChange(n, v);
          }}
          onBlur={handleBlur}
          invalid={invalid}
        />
        <div className='mc-note-text'>{lang.t(LANG_CONST.text.pw_least_chars)}</div>
        <TextField
          template={6}
          name={'password2'}
          type={'password'}
          label={LANG_CONST.confirm_password}
          value={model.input('password2')}
          onChange={(n, v) => {
            model.resetApiState(apiStateId);
            handleChange(n, v);
          }}
          onBlur={handleBlur}
          invalid={invalid}
        />
        <div></div>
      </>
    );
  };

  render() {
    const apiStateId = model.state.verified ? 'resetPw' : 'verify';

    let { invalid, loading, error, errorMessage } = model.getApiState(apiStateId);

    const expired = model.state.resetExpired;
    const expiredIn = (expired - Date.now()) / 1000;
    const blocked = expiredIn > 0;
    if (error === 'BLOCKED') errorMessage = '';
    if (['INVALID_CODE', 'EXPIRED_CODE'].includes(error)) {
      invalid['code'] = errorMessage;
      errorMessage = '';
    }

    if (!model.getApiState('resetPw').success) {
      return (
        <div className={'mc-page-auth-box'}>
          <div className={'mc-box-header'}>
            <h4 className='mc-box-title'>{lang.t(LANG_CONST.set_new_pw)}</h4>
          </div>
          {!!errorMessage && <p className='mc-error'>{errorMessage}</p>}
          <form className='mc-form' onSubmit={this.handleSubmit}>
            {!model.state.verified ? this.renderCodeInput() : this.renderPasswordInput()}

            <MCButton
              key={this.state.renderId}
              large
              type='submit'
              radius
              disabled={blocked || loading}
              loading={loading}
              primary
              dark={!blocked}
              light={blocked}
              label={
                blocked
                  ? lang.t(LANG_CONST.buttons.reset_pw_in, { duration: formatDuration(expiredIn) })
                  : LANG_CONST.buttons.reset_pw
              }
            />

            {!model.state.verified && (
              <div className='mc-label-420'>
                <span className=''>{lang.t(LANG_CONST.notice.no_receive_code)} </span>{' '}
                <Link
                  to={permissions.PAGES[urlPrefix + 'FORGOT_PASSWORD_PAGE'].path}
                  onClick={() => model.resetApiState(apiStateId)}
                  style={{ color: variables['colors-mc-primary'], cursor: 'pointer' }}
                  state={{ no_reset: true }}
                >
                  {lang.t(LANG_CONST.buttons.click_to_resend)}
                </Link>
              </div>
            )}
            <div className='mc-label-420'>
              <span className=''>{lang.t(LANG_CONST.back_to_txt)} </span>
              <Link
                to={permissions.PAGES[urlPrefix + 'LOGIN_PAGE'].path}
                onClick={() => model.resetApiState(apiStateId)}
                style={{ color: variables['colors-mc-primary'], cursor: 'pointer' }}
              >
                {lang.t(LANG_CONST.log_in)}
              </Link>
            </div>
          </form>
        </div>
      );
    }

    return (
      <div className={'mc-page-auth-box mc-page-auth-check-mail'}>
        <div className={'mc-box-header'}>
          <h4 className='mc-box-title'>{lang.t(LANG_CONST.titles.pw_reset)}</h4>
          <div className='mc-box-title-note'>
            <span>{lang.t(LANG_CONST.text.pw_reset_successfully)} </span>
            <br />
            <span>{lang.t(LANG_CONST.text.click_to_login)}</span>
          </div>
        </div>
        <div className='mc-form'>
          <MCButton
            primary
            large
            dark
            radius
            onClick={this.continueBtn}
            loading={model.getApiState('password').loading}
            disabled={model.getApiState('password').loading}
            label={LANG_CONST.buttons.continue}
          />
          <div className='mc-label-420'>
            <span className=''>{lang.t('Back to')} </span>
            <Link
              to={permissions.PAGES.LOGIN_PAGE.path}
              onClick={() => model.resetApiState(apiStateId)}
              style={{ color: variables['colors-mc-primary'], cursor: 'pointer' }}
            >
              {lang.t('log in')}
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(ResetPw);
